export default __webpack_public_path__ + "static/media/Self-Portrait-Nate-Baldwin.6591ee4e.jpg";